// 권한 레벨
export enum PermissionLevel {
  HIDDEN = 0, // 메뉴 숨김
  READ_ONLY = 1, // 읽기 전용 (버튼 비활성화)
  WRITE = 2, // 쓰기 가능
  // 관리자
}

// 메인 메뉴 권한
export interface IMenuPermission {
  menu_name: string;
  permission_level: PermissionLevel;
}

// 서브 메뉴 권한
export interface ISubMenuPermission {
  menu_name: string; // 부모 메뉴 이름
  submenu_name: string; // 서브메뉴 이름
  permission_level: PermissionLevel;
}

// 사용자 권한 응답
export interface IUserPermissions {
  authority_id: number | null;
  authority_name: string | null;
  menu_permissions: IMenuPermission[];
  submenu_permissions: ISubMenuPermission[];
}
